import React, { useEffect, useState } from "react";
import { List } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useStore from "../../store";
import { CognitoUserPool, CognitoUser } from "amazon-cognito-identity-js";
import Item from "./Item/Item";
import { list } from "../settings";

const Sidebar = (props) => {
  const { open, toggleDrawer } = props;
  const navigate = useNavigate();
  const [role, setRole] = useState("");
  const [selectedItemId, setSelectedItemId] = useState();
  const [isOpen, setIsOpen] = React.useState(false);

  const { data, tenantId, isLoggedIn } = useStore((state) => state);
console.log({data: JSON.parse(JSON.stringify(data))})
  const handleListItemClick = (index) => {
    setSelectedItemId(index);
  };

  const onHover = () => {
    if (!isOpen) {
      toggleDrawer();
    }
  };

  useEffect(() => {
    console.log({isLoggedIn})
    if (isLoggedIn) {
      const Pool = new CognitoUserPool({
        UserPoolId: data?.accessToken?.payload.iss.split("/")[3],
        ClientId: data?.accessToken?.payload.client_id,
      });
      // const cognitoUser = Pool.getCurrentUser();
      
      const cognitoUser = new CognitoUser({ Username: data?.accessToken?.payload.username, Pool });
      
      console.log({cognitoUser})
      if (cognitoUser) {
        cognitoUser.getSession((err, session) => {
          console.log({err})
          if (err) {
            console.log(err.message);
          } else {
            setRole(session?.idToken?.payload["custom:role"]);
            console.log({role})
          }
        });
      }
    } else {
      navigate(`/?tenantId=${tenantId}`);
    }
  }, [isLoggedIn, navigate, data, tenantId]);

  return (
    <List
      // onMouseOver={onHover}
      style={{ maxHeight: "100%", overflow: "auto" }}
      sx={{
        width: "100%",
        maxWidth: 360,
        bgcolor: "background.paper",
        height: "80vh",
      }}
    >
      {list.map((el) => (
        <Item
          key={el.id}
          node={el}
          role={role}
          selectedItemId={selectedItemId}
          handleListItemClick={handleListItemClick}
        />
      ))}
    </List>
  );
};

export default Sidebar;
